(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diwali-banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mirari-diwali-slideshow')) {
    customElements.define('mirari-diwali-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.stage = this.querySelector('[data-stage]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Math.max(1000, Number(this.dataset.interval) || 5000);
        this.autoplayEnabled = this.dataset.autoplay !== 'false';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = false;

        const options = { signal: this.controller.signal };

        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-action]');
          if (!control || !this.contains(control)) return;

          event.preventDefault();
          const action = control.dataset.action;

          if (action === 'previous') this.showSlide(this.index - 1);
          if (action === 'next') this.showSlide(this.index + 1);
          if (action === 'go') this.showSlide(Number(control.dataset.slideIndex));

          this.startAutoplay();
        }, options);

        this.addEventListener('pointerenter', () => this.pauseAutoplay(), options);
        this.addEventListener('pointerleave', () => this.resumeAutoplay(), options);
        this.addEventListener('focusin', () => this.pauseAutoplay(), options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resumeAutoplay();
        }, options);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        }, options);

        this.showSlide(this.index);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.controller?.abort();
      }

      showSlide(nextIndex) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        const activeSlide = this.slides[this.index];
        if (this.stage && activeSlide.dataset.ratio) {
          this.stage.style.aspectRatio = activeSlide.dataset.ratio;
        }

        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
        });

        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
      }

      pauseAutoplay() {
        this.paused = true;
        this.stopAutoplay();
      }

      resumeAutoplay() {
        this.paused = false;
        this.startAutoplay();
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplayEnabled || this.reducedMotion || this.paused || this.slides.length < 2 || document.hidden) return;
        this.timer = window.setInterval(() => this.showSlide(this.index + 1), this.interval);
      }

      stopAutoplay() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
